<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Complaint-List",
  short_name: "Complaints",
  path: "list",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
